import { lazy, Suspense } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import Loading from "@/components/molecules/Loading";
import NotFoundPage from "@/components/static/NotFoundPage";
import { camelize } from "@/utils/helpers";

import { type Path, QUOTE } from "../paths";

const stripQuotePrefix = (path: string) => path.replace(`${QUOTE.ROOT}/`, "");

const createRoute = (
  path: Path,
  children: RouteObject[] = [],
  overrides: object = {},
): RouteObject => {
  const slug = stripQuotePrefix(path);
  const componentName = camelize(slug);
  const Page = lazy(() => import(`./${componentName}/page.tsx`));

  return {
    children,
    element: (
      <Suspense fallback={<Loading container="#drawer-content" inContainer />}>
        <Page />
      </Suspense>
    ),
    path: slug,
    ...overrides,
  };
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={QUOTE.ROOT} />,
  },
  {
    path: QUOTE.ROOT,
    children: [
      { element: <Navigate to={QUOTE.DETAIL} />, index: true },
      createRoute(QUOTE.DETAIL),
      createRoute(QUOTE.PAX),
      createRoute(QUOTE.DATE),
      createRoute(QUOTE.DEPARTURE_AIRPORT),
      createRoute(QUOTE.FLIGHT_TIMES),
    ],
  },
  { path: "*", element: <NotFoundPage /> },
];

export default routes;
